<template>
  <base-modal
    hide-footer
    :size="'xl'"
    :modal-id="'move-to-set-banner-modal'"
    @hidden="$emit('onCloseModal', mappingBannerList)"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="copy-banner-head-label px-2 pt-2">
        Move to Banner Set
      </div>
    </template>

    <b-row class="px-2">
      <b-col
        cols="12"
        class="d-flex justify-content-center mb-1"
      >
        <div class="search-move-banner-container">
          <search :on-search-input="onSearchSetBanner" />
        </div>
      </b-col>
      <b-col
        cols="12"
        class="mb-1"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :key="keyChange"
              :fields="fields"
              :items="setBannerListTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              class="move-to-set-banner-table"
            >
              <template #cell(valid_from)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_from)
                }}</span>
              </template>
              <template #cell(valid_through)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_through)
                }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-if="data.item.status"
                    icon="CircleIcon"
                    class="active-icon mr-2"
                  />

                  <span>{{ resolveBannerStatusLabel(data.item.status) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CircleIcon"
                    class="inActive-icon mr-2"
                  />
                  <span class="inActive-label">{{
                    resolveBannerStatusLabel(data.item.status)
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <move-button @onClick="moveToSetBanner($event, data.item)" />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12" class="mb-2">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
import BaseModal from '@core/components/base-modal/BaseModal.vue'
import {
  BRow, BCol, BTable, BSpinner,
} from 'bootstrap-vue'
import Search from '@/views/components/search/Search.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'
import MoveButton from '@/views/components/button/MoveButton.vue'

import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useMoveToSetBannerModal from '../hooks/useMoveToSetBannerModal'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BaseModal,
    BSpinner,
    Search,
    CardNoItem,
    MoveButton,
    PaginationWithReorder,
  },

  props: {
    bannerId: Number,
    mappingBanner: Array,
    setBannerInformation: Object,
  },

  setup(props) {
    const {
      fields,
      setBannerListTable,
      pagination,
      mappingBannerList,
      keyChange,
      loading,
      onModalOpen,
      resolveBannerStatusLabel,
      moveToSetBanner,
      resolveDateWithSeperator,
      onPageChange,
      onSearchSetBanner,
    } = useMoveToSetBannerModal(props)

    return {
      fields,
      setBannerListTable,
      pagination,
      mappingBannerList,
      keyChange,
      loading,
      onModalOpen,
      resolveBannerStatusLabel,
      moveToSetBanner,
      resolveDateWithSeperator,
      onPageChange,
      onSearchSetBanner,
    }
  },
}
</script>

<style>
@import '~@/assets/css/override-styles/status.css';
@import '~@/assets/css/override-styles/loading.css';
@import '~@/assets/css/pages/banner/move-to-set-banner-modal.css';
</style>
